import React, { useEffect, useState } from 'react';
import './App.css';
import { Invoice } from './types';
import { loadInvoices, saveInvoices, seedSample } from './storage';
import InvoiceList from './components/InvoiceList';
import InvoiceForm from './components/InvoiceForm';

function App() {
  const [invoices, setInvoices] = useState<Invoice[]>(() => loadInvoices());
  const [editing, setEditing] = useState<Invoice | null>(null);

  useEffect(() => {
    // seed sample data if empty
    if (invoices.length === 0) {
      const seeded = seedSample();
      if (seeded.length > 0) setInvoices(seeded);
    }
  }, []);

  useEffect(() => {
    saveInvoices(invoices);
  }, [invoices]);

  function handleCreate(inv: Invoice) {
    setInvoices((s) => [inv, ...s]);
  }

  function handleUpdate(updated: Invoice) {
    setInvoices((s) => s.map((i) => (i.id === updated.id ? updated : i)));
    setEditing(null);
  }

  function handleDelete(id: string) {
    setInvoices((s) => s.filter((i) => i.id !== id));
  }

  function handleEdit(id: string) {
    const inv = invoices.find((i) => i.id === id) || null;
    setEditing(inv);
  }

  function handleImport(list: Invoice[]) {
    setInvoices(list);
  }

  return (
    <div className="app-root">
      <header className="app-header">
        <h1>Invoice Manager</h1>
      </header>

      <main className="app-main">
        <section className="left-pane">
          <InvoiceForm
            key={editing ? editing.id : 'new'}
            onCreate={handleCreate}
            onUpdate={handleUpdate}
            editing={editing}
            onImport={handleImport}
          />
        </section>

        <section className="right-pane">
          <InvoiceList
            invoices={invoices}
            onEdit={handleEdit}
            onDelete={handleDelete}
            onImport={handleImport}
          />
        </section>
      </main>
    </div>
  );
}

export default App;
